'use strict';

const MODULE = 'flightsummary';

module.exports = Backbone.View.extend({

    initialize(options) {
        this.options = options;
        this.keys = options.keys;
        this.section = options.section;

        Odigeo.Templates.getGenericTemplates([MODULE])
            .then(({flightsummary}) => {
                const {stopInfoTechnical, stopInfoItem} = flightsummary;
                this.template = stopInfoTechnical;
                this.renderTechnicalStop({stopInfoItem});
                this.render();
            });
    },

    renderTechnicalStop(options) {
        this.templateData = {
            wrapperClass: this.options.isVertical ?
                `odf-space-inner-left-m odf-space-inner-top-s od-collapsible-stop-vertical 
                ${Odigeo.AB.isNewTripDetails ? 'od-collapsible-stop-vertical-v3' : ''}` : '',
            stopInfoItem: options.stopInfoItem,
            stopDuration: this.getStopDuration(),
            alignTitleMargin: this.options.alignWithTitle ? 'od-section-stop-space' : '',
            keys: this.keys,
        };
    },

    render() {
        this.$el.html(this.template(this.templateData));
    },

    getStopDuration() {
        return Odigeo.Utils.convertMinutesToPattern(this.section.stopDuration, this.keys.durationShortPattern) || this.section.stopDuration;
    },
});
